import { post } from '@/axios'

export interface IGroupJoinRequest {
  group_id: string
}

export const postGroupJoin = async (params: IGroupJoinRequest) => {
  const response = await post<null>(`/imApi/group/join`, params)

  return response
}
